// Derive the auth-service host by swapping the leftmost label with "auth".
// www.iwoca.co.uk → auth.iwoca.co.uk, www.iwoca.de → auth.iwoca.de, and
// likewise for iwoca-dev.* — mirrors how auth-service resolves its cookie
// domain from the inbound Host header, so a single deployment serves both
// UK and DE on every environment. In dev and localhost (vite preview used
// by E2E), /auth is a relative path — cypress intercepts it in tests, and
// the vite dev server proxies it otherwise.
export const getAuthBaseUrl = (): string => {
  if (import.meta.env.DEV || window.location.hostname === 'localhost') {
    return '/auth';
  }
  const host = window.location.host;
  // Swap `www.*` → `auth.*`; for any other leftmost label (apex like
  // `iwoca.co.uk`, previews like `signup-preview.iwoca-dev.co.uk`)
  // prepend `auth.`. Stripping the leftmost label unconditionally would
  // turn `iwoca.co.uk` into `auth.co.uk` (a non-existent domain).
  const authHost = host.startsWith('www.')
    ? `auth.${host.slice(4)}`
    : `auth.${host}`;
  return `https://${authHost}`;
};
